import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { AuditLog } from "../../../api/auditApi";
import AuditActionChip from "./AuditActionChip";
import AuditLogDetailsContent from "./AuditLogDetailsContent";

interface AuditDetailsDialogProps {
  open: boolean;
  auditLog: AuditLog | null;
  onClose: () => void;
}

const AuditDetailsDialog: React.FC<AuditDetailsDialogProps> = ({
  open,
  auditLog,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Box>
          <Typography variant="h6">Audit Details</Typography>
          {auditLog && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
              <AuditActionChip action={auditLog.action} />
              <Typography color="text.secondary" sx={{ fontSize: "0.8125rem" }}>
                on {auditLog.entityType} #{auditLog.entityId}
              </Typography>
            </Box>
          )}
        </Box>
        <IconButton aria-label="Close audit details" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <AuditLogDetailsContent auditLog={auditLog} open={open} />
      </DialogContent>
    </Dialog>
  );
};

export default AuditDetailsDialog;
